module.exports = __webpack_public_path__ + "img/formulas-1665.aa328018.png";